export const getCurrentPath = () => window && window.location.pathname;
